import { startRegistration, startAuthentication, browserSupportsWebAuthn } from '@simplewebauthn/browser';
import api from '@/lib/api';

export { browserSupportsWebAuthn };

export interface PasskeySummary {
  id: string;
  deviceName: string | null;
  createdAt: string;
  lastUsedAt: string | null;
}

export async function listPasskeys(): Promise<PasskeySummary[]> {
  return (await api.get('/auth/passkeys')).data.data;
}

export async function registerPasskey(deviceName?: string): Promise<PasskeySummary> {
  const optionsJSON = (await api.post('/auth/passkeys/register-options')).data.data;
  const attestationResponse = await startRegistration({ optionsJSON });
  return (await api.post('/auth/passkeys/register-verify', { attestationResponse, deviceName })).data.data;
}

export async function removePasskey(id: string): Promise<void> {
  await api.delete(`/auth/passkeys/${id}`);
}

export async function loginWithPasskey() {
  const { options, challengeId } = (await api.post('/auth/passkeys/login-options')).data.data;
  const assertionResponse = await startAuthentication({ optionsJSON: options });
  return (await api.post('/auth/passkeys/login-verify', { challengeId, assertionResponse })).data.data;
}
